var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'read-drd-caption-item': true, 'dense': _vm.dense}},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.caption.title)+" ")]),_vm._v(" - "+_vm._s(_vm.caption.description)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }